import React from "react";
import ShopPasswordReset from "../../components/Shop/ShopPasswordReset";

const ShopPasswordResetPage = () => {
  return (
    <div className="min-h-screen">
      <br />
      <br />
      <ShopPasswordReset />
    </div>
  );
};

export default ShopPasswordResetPage;
